module.exports = __webpack_public_path__ + "img/warning_g.10e5cbf7.svg";